module.exports = __webpack_public_path__ + "img/wx1.05262986.png";